import type { IAccountNotification } from "@apis/accounts/types"
import {
  notificationsIconParser,
  notificationsLevelColorParser,
  notificationsIconColorClass,
} from "./utils"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { AccountNotificationButton } from "./AccountNotificationButton"
import { formatDate, timeAgo } from "@utils/formatters"
import { cn } from "@components/ui/lib/utils"

type TAccountNotificationItemProps = {
  account_id: string
  prospect_guid: string
  notification: IAccountNotification
}

export const AccountNotificationItem = ({
  account_id,
  prospect_guid,
  notification,
}: TAccountNotificationItemProps) => {
  const Icon = notificationsIconParser(notification.icon ?? "default")
  const formattedDate = formatDate(notification.date, "M/d/yyyy h:mm a")

  const borderColor = notificationsLevelColorParser(
    notification.level ?? "default",
  )

  return (
    <div
      className={`tw:flex tw:gap-3 tw:py-4 tw:hover:bg-gray-100 ${borderColor}`}
    >
      <div className="tw:w-2/12 tw:text-center">
        <Tooltip key={notification.date}>
          <TooltipTrigger>
            {Icon && (
              <Icon
                className={cn(
                  "tw:inline-block tw:h-6 tw:w-6 tw:translate-y-1 tw:transform",
                  notificationsIconColorClass(notification.level ?? "default"),
                )}
              />
            )}

            <div className="tw:mt-1 tw:text-xs tw:text-muted-foreground">
              {timeAgo(notification.date)}
            </div>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <span>{formattedDate}</span>
          </TooltipContent>
        </Tooltip>
      </div>

      <div className="tw:w-10/12">
        <div className="tw:flex tw:justify-between tw:text-sm tw:font-medium tw:text-foreground">
          <p>{notification.title}</p>
          <p className="tw:text-xs tw:font-normal">{formattedDate}</p>
        </div>
        <div
          className="tw:mt-1 tw:text-xs tw:whitespace-pre-wrap tw:text-gray-600"
          dangerouslySetInnerHTML={{ __html: notification.description }}
        />
        <AccountNotificationButton
          account_id={account_id}
          prospect_guid={prospect_guid}
          notification={notification}
        />
      </div>
    </div>
  )
}
